import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import styles from './People.module.scss';
import { Block, BlockHeader, BlockContent, ResponsiveImage, Typography, Card } from 'components/elements';
import { WPAcfTeam } from 'types/acf/people';
import { isMobile } from 'utils';
import { useCurrentWidth } from 'hooks/dom';

interface OwnProps {
  team: WPAcfTeam | null;
  teamIndex: number;
}

type TeamProps = JSX.IntrinsicElements['div'] & OwnProps;

const Team: FunctionComponent<TeamProps> = props => {
  const { team, teamIndex } = props;
  const [tileHeight, setTileHeight] = useState(0);
  const containerRef = useRef();
  const windowWidth = useCurrentWidth();

  const selectBiggest = () => {
    let height = 0;
    // @ts-ignore
    document.querySelectorAll(`[data-parent="team-${teamIndex}"] [data-type="team-tile"]`).forEach((item: Element) => {
      if (item.clientHeight > height) {
        height = item.clientHeight;
      }
    });
    return height;
  };

  const wrapperRef = useCallback(node => {
    if (node && !isMobile()) {
      containerRef.current = node;
      setTileHeight(selectBiggest());
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (containerRef?.current && !isMobile()) {
      setTileHeight(selectBiggest());
    }
    // eslint-disable-next-line
  }, [windowWidth, team]);

  const onLoad = (prop: any) => {
    setTileHeight(selectBiggest());
  };

  if (!team || !team.members || team.members.length === 0) {
    return null;
  }

  const { members, header } = team;

  return (
    <Block id="people" data-module="people">
      <BlockContent direction="row" ref={wrapperRef}>
        {header && <BlockHeader className={styles.header}>{header}</BlockHeader>}
        {members.map((member, index) => {
          const { image, description, name } = member;

          return (
            <div data-parent={`team-${teamIndex}`} className={styles.item} key={`people-team-item-${index}`}>
              <Card {...(tileHeight && { maxHeight: tileHeight })}>
                <div data-type="team-tile" className={styles.content}>
                  {image && (
                    <ResponsiveImage
                      className={styles.image}
                      desktopImage={{ config: image, imgProps: { sizes: '33.333vw', onLoad } }}
                      mobileImage={{ config: image, imgProps: { sizes: '100vw', onLoad } }}
                    />
                  )}
                  <Typography mobile="new_neue_20_h2" tablet="new_neue_20_h2" desktop="new_neue_20_h2" className={styles.title}>
                    {name}
                  </Typography>
                  <Typography className={styles.description} mobile="new_ibm_regular_16" tablet="new_ibm_regular_16" desktop="new_ibm_regular_16" as="p">
                    {description}
                  </Typography>
                </div>
              </Card>
            </div>
          );
        })}
      </BlockContent>
    </Block>
  );
};

export default Team;
